import React from 'react'

interface AISearchIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number
  color?: string
}

const AISearchIcon = ({
  size = 18,
  color = 'currentColor',
  ...svgProps
}: AISearchIconProps): React.ReactElement => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 18 18'
      fill={color}
      xmlns='http://www.w3.org/2000/svg'
      {...svgProps}
    >
      <g clipPath='url(#clip0_ai_search)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M2.33967 1.62075C2.52506 0.899854 3.54889 0.899855 3.73429 1.62075L3.99634 2.63973C4.0617 2.89389 4.26017 3.09236 4.51433 3.15772L5.53325 3.41975C6.25415 3.60514 6.25416 4.62897 5.53326 4.81437L4.51432 5.07642C4.26017 5.14178 4.06171 5.34024 3.99635 5.5944L3.73429 6.61339C3.54889 7.33428 2.52506 7.33428 2.33967 6.61339L2.07761 5.5944C2.01225 5.34024 1.81378 5.14178 1.55963 5.07642L0.54069 4.81437C-0.180205 4.62897 -0.180201 3.60514 0.540697 3.41975L1.55962 3.15772C1.81378 3.09236 2.01225 2.89389 2.07761 2.63973L2.33967 1.62075ZM3.6416 8.56397C3.82699 7.84305 4.85083 7.84305 5.03622 8.56397L5.5646 10.6185C5.62996 10.8727 5.82843 11.0712 6.08258 11.1365L8.13715 11.6649C8.85809 11.8503 8.85802 12.8741 8.13715 13.0595L6.08258 13.5878C5.82843 13.6532 5.62996 13.8517 5.5646 14.1059L5.03623 16.1604C4.85083 16.8813 3.82699 16.8813 3.6416 16.1604L3.11322 14.1059C3.04786 13.8517 2.8494 13.6532 2.59524 13.5878L0.540672 13.0595C-0.180223 12.8741 -0.180225 11.8503 0.54067 11.6649L2.59524 11.1365C2.8494 11.0712 3.04786 10.8727 3.11322 10.6185L3.6416 8.56397ZM10.6484 9.76047C12.4377 9.76047 13.8883 8.30989 13.8883 6.52049C13.8883 4.73111 12.4377 3.28053 10.6484 3.28053C8.85895 3.28053 7.40837 4.73111 7.40837 6.52049C7.40837 8.30989 8.85895 9.76047 10.6484 9.76047ZM13.9348 9.03845C14.4701 8.34077 14.7883 7.46779 14.7883 6.52049C14.7883 4.23405 12.9348 2.38054 10.6484 2.38054C8.36186 2.38054 6.50838 4.23405 6.50838 6.52049C6.50838 8.8069 8.36186 10.6605 10.6484 10.6605C11.6632 10.6605 12.5927 10.2953 13.3128 9.68919L16.7379 13.1143L17.3743 12.4779L13.9348 9.03845Z'
        />
      </g>
      <defs>
        <clipPath id='clip0_ai_search'>
          <rect width='18' height='18' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default AISearchIcon
